import {
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Container,
    Drawer,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import { useGetProductsQuery } from '../../store/productApi';
import DropzoneWrapper from '../../styles/react-dropzone';

const AddProduct = (props) => {
  const { show, setShow, setReload } = props
  const [loading, setLoading] = useState(false)
  const [category1, setCategory1] = useState([])
  const [category2, setCategory2] = useState([])
  const [category3, setCategory3] = useState([])
  const [files, setFiles] = useState([])
  const [state, setState] = useState({
    brandnew: false,
    best: false,
    sale: false
  })
  const { refetch } = useGetProductsQuery();
  const { brandnew, best, sale } = state
  const defaultValues = {
    name: '',
    brand: '',
    price: '',
    sale_price: '',
    stock: ''
  }
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({ defaultValues })

  useEffect(() => {
    if(!show) {
      reset(defaultValues);
      setFiles([]);
      setState({
        brandnew: false,
        best: false,
        sale: false
      })
      setCategory2([])
      setCategory3([])
    }
  }, [show])

  const loadCategory1 = () => {
    const fetchData = async () => {
        try {
            const _response = await apiService.get('/category/level/1');
            const _payload = _response.data;
            setCategory1(_payload.list);
        } catch (error) {
            console.error('Error loading category1:', error);
        }
    }

    fetchData();
  }

  const loadCategory2 = (level) => {
    const fetchData = async () => {
        try {
            const _response = await apiService.get('/category/level/2', {
                params: { q: level }
            });
            const _payload = _response.data;
            setCategory2(_payload.list);
        } catch (error) {
            console.error('Error loading category2:', error);
        }
    }

    fetchData();
  }

  const loadCategory3 = (level) => {
    const fetchData = async () => {
        try {
            const _response = await apiService.get('/category/level/3', {
                params: { q: level }
            });
            const _payload = _response.data;
            setCategory3(_payload.list);
        } catch (error) {
            console.error('Error loading category3:', error);
        }
    }

    fetchData();
  }

  useEffect(loadCategory1, [])

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked })
  }

  const getCategoryId = (level1, level2, level3, callback) => {
    const fetchData = async () => {
      try {
        const _response = await apiService.get('/category/level', {
          params: { level1, level2, level3 }
        });
        const _payload = _response.data;
        callback(_payload.data.id, _payload.data.levelname);
      } catch (error) {
        console.error('Error getting category ID:', error);
      }
    }

    fetchData();
  }

  const onSubmit = async (data, e) => {
    setLoading(true)

    const [file] = files;
    const attributes = ['brandnew', 'best', 'sale'];
    const attrs = [];

    attributes.forEach(attr => {
        if (eval(attr)) {
            attrs.push(attr);
        }
    });

    getCategoryId(data.category1, data.category2, data.category3, async (categoryid, categoryname) => {
        const attr = attrs?.length > 0 ? attrs.join(",") : '';

        const formData = new FormData()
        formData.append('name', data.name);
        formData.append('category1', data.category1);
        formData.append('category2', data.category2);
        formData.append('category3', data.category3);
        formData.append('brand', data.brand);
        formData.append('price', data.price);
        formData.append('sale_price', data.sale_price);
        formData.append('stock_kor', data.stock_kor);
        formData.append('stock_intl', data.stock_intl);
        formData.append('keywords', data.keywords);
        formData.append('attrib', attr);
        formData.append('file', file);

        try {
            await apiService.post('/products', formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });
            toast.success('등록 되었습니다.');
            refetch();
            setReload(reload => reload + 1);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setShow(false);
        }
    }) 
  }

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
    }
    setShow(open);
  };

  return (
    <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
        <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>
            <form onSubmit={handleSubmit(onSubmit)} id="productform">
                <Box sx={{ mb: 9, textAlign: 'center' }}>
                <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                    상품 등록
                </Typography>
                </Box>

                <Grid container spacing={6}>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                    <Controller
                        name='name'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <TextField
                            value={value}
                            label='이름'
                            id='name'
                            onChange={onChange}
                            placeholder='이름을 입력해주세요'
                            error={Boolean(errors.name)}
                            aria-describedby='validation-async-name'
                            variant="standard"
                        />
                        )}
                    />
                    {errors.name && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-name'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                    <InputLabel id='type1'>1차 카테고리</InputLabel>
                    <Controller
                        name='category1'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <Select
                            label='1차 카테고리'
                            value={value}
                            onChange={(e) => {
                            onChange(e)
                            setCategory3([])
                            loadCategory2(e.target.value)                          
                            }}
                            labelId='type1'
                            error={Boolean(errors.category1)}
                            variant="standard"
                        >
                            {category1 !== undefined &&
                            category1.map(item => (
                                <MenuItem key={item} value={item}>
                                {item}
                                </MenuItem>
                            ))}
                        </Select>
                        )}
                    />
                    {errors.category1 && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-category1'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                    <InputLabel id='type2'>2차 카테고리</InputLabel>
                    <Controller
                        name='category2'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <Select
                            label='2차 카테고리'
                            value={value}
                            disabled={category2.length === 0 ? true : false}                 
                            onChange={(e) => {
                            onChange(e)
                            loadCategory3(e.target.value)
                            }}
                            labelId='type2'
                            error={Boolean(errors.category2)}
                            variant="standard"
                        >
                            {category2 !== undefined &&
                            category2.map(item => (
                                <MenuItem key={item} value={item}>
                                {item}
                                </MenuItem>
                            ))}
                        </Select>
                        )}
                    />
                    {errors.category2 && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-category2'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                    <InputLabel id='type3'>3차 카테고리</InputLabel>
                    <Controller
                        name='category3'
                        control={control}
                        rules={{ required: false }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <Select
                            label='3차 카테고리'
                            value={value}
                            disabled={category3.length === 0 ? true : false}
                            onChange={onChange}
                            labelId='type3'
                            variant="standard"
                        >
                            {category3 !== undefined &&
                            category3.map(item => (
                                <MenuItem key={item} value={item}>
                                {item}
                                </MenuItem>
                            ))}
                        </Select>
                        )}
                    />
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                    <Controller
                        name='brand'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <TextField
                            value={value}
                            label='브랜드'
                            id='brand'
                            onChange={onChange}
                            placeholder='브랜드를 입력해주세요'
                            error={Boolean(errors.brand)}
                            aria-describedby='validation-async-brand'
                            variant="standard"
                        />
                        )}
                    />
                    {errors.brand && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-brand'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                    <Controller
                        name='price'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <TextField
                            value={value}
                            label='단가'
                            id='price'
                            onChange={onChange}
                            placeholder='단가를 입력해주세요'
                            error={Boolean(errors.price)}
                            aria-describedby='validation-async-price'
                            variant="standard"
                        />
                        )}
                    />
                    {errors.price && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-price'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='sale_price'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='판매가'
                                    id='sale_price'
                                    onChange={onChange}
                                    placeholder='판매가를 입력해주세요'
                                    error={Boolean(errors.sale_price)}
                                    aria-describedby='validation-async-sale_price'
                                    variant="standard"
                                />
                            )}
                        />
                        {errors.sale_price && (
                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-sale_price'>
                                필수
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='stock_kor'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='국내 재고수량'
                                    id='stock_kor'
                                    onChange={onChange}
                                    placeholder='재고수량를 입력해주세요'
                                    error={Boolean(errors.stock_kor)}
                                    aria-describedby='validation-async-stock_kor'
                                    variant="standard"
                                />
                            )}
                        />
                        {errors.stock_kor && (
                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-stock_kor'>
                                필수
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                        <Controller
                            name='stock_intl'
                            control={control}
                            rules={{ required: true }}
                            defaultValue=""
                            render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='해외 재고수량'
                                    id='stock_intl'
                                    onChange={onChange}
                                    placeholder='재고수량를 입력해주세요'
                                    error={Boolean(errors.stock_intl)}
                                    aria-describedby='validation-async-stock_intl'
                                    variant="standard"
                                />
                            )}
                        />
                        {errors.stock_intl && (
                            <FormHelperText sx={{ color: 'error.main' }} id='validation-async-stock_intl'>
                                필수
                            </FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                
                <Grid item xs={6}>
                    <FormControl fullWidth>
                    <Controller
                        name='keywords'
                        control={control}
                        rules={{ required: true }}
                        defaultValue=""
                        render={({ field: { value, onChange } }) => (
                        <TextField
                            value={value}
                            label='태그'
                            id='keywords'
                            onChange={onChange}
                            placeholder='짭은 이름을 입력해주세요'
                            error={Boolean(errors.keywords)}
                            aria-describedby='validation-async-keywords'
                            variant="standard"
                        />
                        )}
                    />
                    {errors.keywords && (
                        <FormHelperText sx={{ color: 'error.main' }} id='validation-async-keywords'>
                        필수
                        </FormHelperText>
                    )}
                    </FormControl>
                </Grid>

                <Grid item xs={6}>
                    <FormControl>
                    <FormLabel>상품속성</FormLabel>
                    <FormGroup row>
                        <FormControlLabel
                        label='신상품'
                        control={<Checkbox checked={brandnew} onChange={handleChange} name='brandnew' />}
                        />
                        <FormControlLabel
                        label='베스트'
                        control={<Checkbox checked={best} onChange={handleChange} name='best' />}
                        />
                        <FormControlLabel
                        label='세일'
                        control={<Checkbox checked={sale} onChange={handleChange} name='sale' />}
                        />
                    </FormGroup>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <DropzoneWrapper>
                    <FileUploaderSingle files={files} setFiles={setFiles} />
                    </DropzoneWrapper>
                </Grid>

                </Grid>
            </form>

            <Stack direction="row" spacing={2} sx={{ py: 16, justifyContent: 'center' }}>
                <Button type="submit" form="productform" variant='contained'>
                    {loading ? (
                    <CircularProgress
                        sx={{
                        color: 'common.white',
                        width: '20px !important',
                        height: '20px !important',
                        mr: theme => theme.spacing(2)
                        }}
                    />
                    ) : null}
                    등록
                </Button>
                <Button variant='outlined' color='secondary' onClick={() => setShow(false)}>
                    취소
                </Button>
            </Stack>
        </Container>
    </Drawer>
  )
}

export default AddProduct
